import { AxiosPromise } from 'axios';

import { GetSupportMessagesParams, PaginatedResponse, SupportMessage, SupportMessageListItem } from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/support-messages';

/**
 * Получение списка обращений с пагинацией и фильтрацией
 */
export const getSupportMessages = async (
  params?: GetSupportMessagesParams,
): AxiosPromise<PaginatedResponse<SupportMessageListItem>> =>
  apiInstance.get(BASE_URL, {
    params,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Получение обращения по ID (автоматически помечается как прочитанное)
 */
export const getSupportMessageById = async (id: string): AxiosPromise<SupportMessage> =>
  apiInstance.get(`${BASE_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });

/**
 * Ответить на обращение (отправляет email)
 */
export const replySupportMessage = async (id: string, data: { replyText: string }): AxiosPromise<SupportMessage> =>
  apiInstance.post(`${BASE_URL}/${id}/reply`, data, {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
    },
  });
